import { AgreeToTermsPolicy, SignInMode } from '@logto/schemas';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import LandingPageLayout from '@/Layout/LandingPageLayout';
import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';
import SupportLinks from '@/components/SupportLinks';
import TextLink from '@/components/TextLink';
import TermsAndPrivacyLinks from '@/containers/TermsAndPrivacyLinks';
import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import { useSieMethods } from '@/hooks/use-sie';
import useTerms from '@/hooks/use-terms';
import ErrorPage from '@/pages/ErrorPage';

import PasswordForm from './PasswordForm';
import styles from './index.module.scss';

const SignInPassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigateWithPreservedSearchParams();
  const { signInMethods, signUpMethods, signInMode } = useSieMethods();
  const { agreeToTermsPolicy } = useTerms();
  const { identifierInputValue } = useContext(UserInteractionContext);

  if (!identifierInputValue) {
    return <ErrorPage title="error.invalid_session" />;
  }

  const { type, value } = identifierInputValue;
  const methodSetting = signInMethods.find((method) => method.identifier === type);

  // Sign-in method not enabled
  if (!methodSetting?.password) {
    return <ErrorPage />;
  }

  return (
    <LandingPageLayout
      title="description.sign_in_to_your_account"
      onBack={() => {
        navigate(-1);
      }}
    >
      <PasswordForm
        autoFocus
        identifier={methodSetting.identifier}
        value={value}
        isVerificationCodeEnabled={methodSetting.verificationCode}
      />
      {signInMode === SignInMode.SignInAndRegister && signUpMethods.length > 0 && (
        <div className={styles.createAccount}>
          {t('description.no_account')}{' '}
          <TextLink replace to="/custom-register" text="action.create_account" />
        </div>
      )}
      {agreeToTermsPolicy !== AgreeToTermsPolicy.Manual && (
        <TermsAndPrivacyLinks className={styles.terms} />
      )}
      <SupportLinks />
    </LandingPageLayout>
  );
};

export default SignInPassword;
